import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/CategoryHeader/CategoryHeader.js";
const variants = import.meta.webpackContext("/components/CategoryHeader", { recursive: true, regExp: /\.\/__variants__\/plp\-grid\-expansion\-four_v2\/(?:full_width|v2)\/CategoryHeader\.js/ });
export default pointCut({ joinPoint, variants });